import { IDeskActivityOverviewStats } from '@kcftech/prometheustypescriptapiclient';
import { useMemo } from 'react';
import { MultiSelectQuickFilterButton } from 'shared/filter_pane/MultiSelectQuickFilterButton';
import { sortBy } from 'utils/array';

export type FaultTypesFilterButtonProps = {
    faultTypeIds: string[];
    onChangeFaultTypeIds: (faultTypeIds: string[]) => void;
    availableFaultTypes: IDeskActivityOverviewStats['FaultTypes'] | undefined;
};

export function FaultTypesFilterButton({
    faultTypeIds,
    onChangeFaultTypeIds,
    availableFaultTypes,
}: FaultTypesFilterButtonProps) {
    const options = useMemo(() => {
        if (!availableFaultTypes) {
            return [];
        }

        // Create options from the available fault types in the data
        // Sort by fault type name
        return sortBy(availableFaultTypes, (ft) => ft.FaultTypeName).map((faultType) => ({
            value: faultType.FaultTypeId,
            label: faultType.FaultTypeName,
        }));
    }, [availableFaultTypes]);

    return (
        <MultiSelectQuickFilterButton
            id="fault-types-filter"
            label="Fault Types"
            selectedValues={faultTypeIds}
            onChangeValues={onChangeFaultTypeIds}
            options={options}
        />
    );
}
